

















































































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class SimpleTable extends Vue {
  public name: string = "SimpleTable";

  @Prop({required: false, default: false})
  public isBordered!: boolean;

  @Prop({required: false, default: false})
  public isStriped!: boolean;

  @Prop({required: false, default: false})
  public isNarrow!: boolean;

  @Prop({required: false, default: false})
  public isHoverable!: boolean;

  @Prop({required: false, default: false})
  public isFullWidth!: boolean;

}
